import React, { useState } from "react";
import {
  Button,
  Modal,
  ModalBody,
  Input,
  Label,
  FormGroup,
  Form,
} from "reactstrap";

const NotificationAddEditModal = ({
  setNotificationAddEditModalOpen,
  notificationAddEditModalOpen,
}) => {
  const [formData, setFormData] = useState({
    name: "",
    incentiveType: "",
    videoTitle: "",
    videoLink: "",
    quota: "on",
    status: true,
    sendTo: [], // <-- added
  });

  const sendToOptions = [
    { label: "Candidate", value: "candidate" },
    { label: "Client", value: "client" },
    { label: "Caller", value: "caller" },
    { label: "Team Lead", value: "team_lead" },
    { label: "Account Executive", value: "account_executive" },
    { label: "Manager", value: "manager" },
    { label: "Admin", value: "admin" },
  ];

  // Handle all normal input changes
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  // Handle checkbox list (multi-select)
  const handleCheckboxChange = (value) => {
    setFormData((prev) => {
      const exists = prev.sendTo.includes(value);
      return {
        ...prev,
        sendTo: exists
          ? prev.sendTo.filter((v) => v !== value)
          : [...prev.sendTo, value],
      };
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // console.log("Form Data:", formData);
  };

  const closeModal = () => setNotificationAddEditModalOpen(false);

  return (
    <Modal
      isOpen={notificationAddEditModalOpen}
      toggle={closeModal}
      backdrop="static"
      className="modal-full-height"
      centered
    >
      <ModalBody className="p-4 modal-height-fixed">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h5 className="fw-bold mb-0">New Settings</h5>
          <Button close onClick={closeModal} />
        </div>
        <hr />

        <Form onSubmit={handleSubmit}>
          {/* Name */}
          <FormGroup>
            <Label>Name</Label>
            <Input
              type="text"
              name="name"
              placeholder="Name"
              value={formData.name}
              onChange={handleChange}
            />
          </FormGroup>

          {/* Send To */}
          <FormGroup className="mt-3">
            <Label>Send To</Label>

            <div className="row">
              {sendToOptions.map((item) => (
                <div key={item.value} className="col-md-5 mb-2">
                  <Input
                    type="checkbox"
                    id={item.value}
                    defaultChecked={formData.sendTo.includes(item.value)}
                    onChange={() => handleCheckboxChange(item.value)}
                  />
                  <Label for={item.value} className="ms-2">
                    {item.label}
                  </Label>
                </div>
              ))}
            </div>
          </FormGroup>

          {/* Status */}
          <FormGroup>
            <Label>Status</Label>
            <div className="input-box d-flex align-items-center justify-content-between">
              <span className="text-muted">Status</span>
              <div>
                <Input
                  type="radio"
                  name="quota"
                  value="active"
                  defaultChecked={formData.quota === "active"}
                  onChange={handleChange}
                />{" "}
                Active
                <Input
                  type="radio"
                  name="quota"
                  value="deactive"
                  defaultChecked={formData.quota === "deactive"}
                  onChange={handleChange}
                  className="ms-3"
                />{" "}
                Deactive
              </div>
            </div>
          </FormGroup>

          {/* Save */}
          <div className="text-end mt-3">
            <Button color="primary" type="submit">
              Save
            </Button>
          </div>
        </Form>
      </ModalBody>
    </Modal>
  );
};

export default NotificationAddEditModal;
